module.exports = __webpack_public_path__ + "img/dashboard-progress.b7f8ac42.svg";